export const MAX_BULK_ITEMS = 100;
export const MAX_FILE_SIZE_BYTES = 500 * 1024; // 500 KB
export const ALLOWED_EXTENSIONS = ['txt', 'csv', 'tsv', 'xls', 'xlsx'];
export const EXCEL_EXTENSIONS = ['xls', 'xlsx'];
export const ALLOWED_MIME_TYPES = [
  'text/plain',
  'text/csv',
  'text/tab-separated-values',
  'application/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
